import React, { useEffect, useState } from "react"
import "../../assets/stylesheets/components/tires/confirmation.scss"
import { connect } from "react-redux"
import placeholderCar from "../../assets/images/car.svg"
import { Accordion, Icon, Select, Loader, Popup, Dropdown } from "semantic-ui-react"
import phoneIcon from "../../assets/images/phone-icon.svg"
import calendarIcon from "../../assets/images/calendar-icon.svg"
import infoIcon from "../../assets/images/info_black.svg"
import { TiresBottomNav } from "../../layouts/TiresLayout"
import { navigationPaths } from "../../constants/paths"
import visaCard from "../../assets/images/Visa.svg"
import masterCard from "../../assets/images/master-card.svg"
import achLogo from "../../assets/images/ach_logo.svg"
import creditCard from "../../assets/images/credit-card.svg"
import amexLogo from "../../assets/images/AmericanExpress.svg"
import paypalLogo from "../../assets/images/pay_pal_account.svg"
import { SUCCESS } from "../../constants/tires"
import { formatDateToYYYYMMDD, formatTime, formatDate } from "../../helpers/dateHelpers"
import PromotionalCodeLink from "../../components/services/PromotionalCodeLink"
import CustomNotification from "../../components/shared/CustomNotification"
import { getSubdomain } from "../../components/shared/StylesheetInjector"
import { FLEETCOR } from "../../constants/application"
import { gaJSON, trackFirebaseAnalytics } from "../../helpers/googleAnalyticsHelpers"
import { isEmpty } from "lodash"

const Confirmation = ({
  shop,
  tire,
  vehicle,
  dispatch,
  history,
  date,
  time,
  selectedTireQuantity,
  user
}) => {
  const [showOrderDetails, setShowOrderDetails] = useState(false)
  const [showAppointmentDetails, setShowAppointmentDetails] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [orderDetails, setOrderDetails] = useState(null)
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(null)
  const [orderLoading, setOrderLoading] = useState(false)
  const [tireQuantity, setTireQuantity] = useState(selectedTireQuantity)
  const [paymentMethods, setPaymentMethods] = useState([])

  const handleOrderDetailsAccordion = () => {
    setShowOrderDetails(!showOrderDetails)
  }

  const handleApptDetailsAccordion = () => {
    setShowAppointmentDetails(!showAppointmentDetails)
  }

  const fetchTireBookingPreview = (tireQty) => {
    dispatch({
      type: "TIRE_BOOKING_PREVIEW_SAGA",
      payload: {
        shop_id: shop.id,
        supplier: tire.supplier,
        tires: [
          {
            tire_id: tire.id,
            quantity: tireQty
          }
        ]
      },
      callback: (res, data) => {
        if (res === SUCCESS) {
          setOrderDetails(data.tires_preview)
        } else {
          CustomNotification("danger", "Error", data.error)
        }
        setIsLoading(false)
      }
    })
  }

  useEffect(() => {
    setIsLoading(true)
    fetchTireBookingPreview(tireQuantity)
  }, [])

  useEffect(() => {
    if (getSubdomain() !== FLEETCOR) {
      dispatch({
        type: "PAYMENT_METHODS_LOAD_SAGA",
        payload: {},
        callback: (status, data) => {
          const paymentMethods = Array.isArray(data)
            ? data.filter((pm) => pm.customer_ids.includes(user?.id))
            : []
          setPaymentMethods(paymentMethods)
          if (isEmpty(paymentMethods)) {
            CustomNotification(
              "danger",
              "Error",
              "You do not have any payment methods. Please add a payment method in Account Settings."
            )
          } else {
            const paymentMethod = paymentMethods.find((pm) => pm.is_default)
            setDefaultPaymentMethod(paymentMethod)
          }
        }
      })
    }
  }, [])

  const getPaymentLogo = (defaultPaymentMethod) => {
    if (defaultPaymentMethod?.type === "credit_card") {
      if (String(defaultPaymentMethod?.card_type)?.toLowerCase() === "visa") {
        return visaCard
      }
      if (String(defaultPaymentMethod?.card_type)?.toLowerCase() === "american express") {
        return amexLogo
      }
      if (String(defaultPaymentMethod?.card_type)?.toLowerCase() === "mastercard") {
        return masterCard
      }
      return creditCard
    }

    if (defaultPaymentMethod?.type === "ach") {
      return achLogo
    }

    if (defaultPaymentMethod?.type === "pay_pal_account") {
      return paypalLogo
    }
  }

  const paymentMethodsDropdown = paymentMethods.map((pm) => ({
    key: pm.id,
    value: pm.id,
    text: "**** " + pm.last_4,
    image: getPaymentLogo(pm)
  }))

  if (isLoading) {
    return (
      <>
        <h2 className="text-lg font-semibold !my-4 text-center tires-step-header">
          Step 6 / 6: Confirmation
        </h2>
        <div
          className="confirmation-container"
          style={{ height: "65vh", display: "flex", justifyContent: "center" }}
        >
          <Loader active inline="centered" size="large" />
        </div>
      </>
    )
  }

  const tiresTotalCost = (tire?.price * tireQuantity + orderDetails?.delivery_fee).toFixed(2)
  const installationTotalCost = Number(orderDetails?.installation_fee).toFixed(2)
  const totalTax = Number(orderDetails?.tax_amount).toFixed(2)
  const orderTotal = (
    Number(tiresTotalCost) +
    Number(installationTotalCost) +
    Number(totalTax) +
    Number(orderDetails?.transaction_fee)
  ).toFixed(2)

  const bookTires = () => {
    trackFirebaseAnalytics({
      event: gaJSON.tire_order_submitted,
      params: {
        vehicle_id: vehicle.id,
        user_role: user.roles.toString()
      }
    })

    const payload = {
      shop_id: shop?.id,
      vehicle_id: vehicle?.id,
      token: defaultPaymentMethod?.token,
      amount: Number(orderTotal).toFixed(2),
      appointment_datetime: `${formatDateToYYYYMMDD(date)} ${time}`,
      payment_type: getSubdomain() === FLEETCOR ? "fleetcor" : "braintree",
      tax: Number(totalTax),
      tires: orderDetails?.items?.[0]?.tires ?? [],
      note: "",
      transaction_fee: orderDetails?.transaction_fee ?? 0,
      supplier: tire?.supplier ?? "",
      tire_image: tire?.image ?? "",
      tire_brand: tire?.brand ?? "",
      tire_details: tire?.size ?? ""
    }
    setOrderLoading(true)
    dispatch({
      type: "BOOK_TIRE_ORDER_SAGA",
      payload: payload,
      callback: (status, data) => {
        setOrderLoading(false)
        if (status === SUCCESS) {
          history.push({
            pathname: navigationPaths.tireOrderDetails(data?.shop_order?.id)
          })
          sessionStorage.removeItem("tireState")
        } else {
          return CustomNotification("danger", "Error", data.error)
        }
      }
    })
  }

  const tireQuantityOptions = [
    { key: "1", value: "1", text: "1" },
    { key: "2", value: "2", text: "2" },
    { key: "3", value: "3", text: "3" },
    { key: "4", value: "4", text: "4" }
  ]

  return (
    <>
      <h2 className="text-lg font-semibold !my-4 text-center tires-step-header">
        Step 6 / 6: Confirmation
      </h2>
      <div className="px-[10px]">
        <div className="confirmation-container">
          <div className="vehicle-header">
            <div className="vehicle-title">
              <b>Vehicle</b>
            </div>
            <div className="vehicle-details-row">
              <img
                src={vehicle && vehicle.dashboard_url ? vehicle.dashboard_url : placeholderCar}
                alt={vehicle ? `${vehicle.year} ${vehicle.make} ${vehicle.model}` : "Vehicle"}
                className="vehicle-image"
              />
              <div className="vehicle-info">
                <div className="vehicle-name">
                  <b>
                    {vehicle ? `${vehicle.year} ${vehicle.make} ${vehicle.model}` : "Loading..."}
                  </b>
                </div>
                <div className="vehicle-vin">{vehicle ? `VIN: ${vehicle.vin}` : "NA"}</div>
              </div>
            </div>
          </div>
          <hr className="horizontal-rule" />
          <Accordion fluid>
            <Accordion.Title active={showOrderDetails} onClick={handleOrderDetailsAccordion}>
              <div
                style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
              >
                <div>
                  <Icon
                    name={showOrderDetails ? "chevron up" : "chevron down"}
                    className="chevron-down"
                  />
                  <label className="accordion-title">Tire order details</label>
                </div>
                <p className="price font-bold font-18">
                  $
                  {Number(tiresTotalCost).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </p>
              </div>
            </Accordion.Title>
            <Accordion.Content active={showOrderDetails}>
              <div className="tire-details-row">
                <div className="tire-img-details">
                  <img className="tire-img" src={tire?.image ?? placeholderCar} />
                  <div className="tire-details">
                    <p className="font-18 font-bold margin-0">
                      {tire?.brand} {tire?.model}
                    </p>
                    <p className="margin-0">{tire?.size}</p>
                    <div className="tire-extra-info margin-0">
                      <p>
                        Run flat: <b>{tire?.run_flat ? "Yes" : "No"}</b>
                      </p>
                      <p>
                        Load range: <b>{tire?.load_range || "NA"}</b>
                      </p>
                      <p>
                        Speed rating: <b>{tire?.speed_rating || "NA"}</b>
                      </p>
                    </div>
                    <div className="quantity-details margin-0 items-center">
                      <b>Quantity</b>
                      <Select
                        placeholder={tireQuantity}
                        options={tireQuantityOptions}
                        style={{ width: "50px" }}
                        onChange={(e, data) => {
                          setTireQuantity(Number(data.value))
                          setIsLoading(true)
                          fetchTireBookingPreview(Number(data.value))
                        }}
                      />
                      <p>${tire?.price} / tire</p>
                    </div>
                  </div>
                </div>
                <p className="price font-medium font-18">
                  $
                  {Number(tire?.price * tireQuantity).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </p>
              </div>
              <div className="pricing-details">
                <p>Subtotal</p>
                <p className="font-bold">
                  $
                  {Number(tire?.price * tireQuantity).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </p>
              </div>
              <div className="pricing-details">
                <p>Delivery fee</p>
                <p className="font-bold">${Number(orderDetails?.delivery_fee).toFixed(2)}</p>
              </div>
              <div className="pricing-details">
                <p className="font-bold">Tires total</p>
                <p className="font-bold">
                  $
                  {Number(tiresTotalCost).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </p>
              </div>
            </Accordion.Content>
          </Accordion>
          <hr className="horizontal-rule" />
          <Accordion fluid>
            <Accordion.Title active={showAppointmentDetails} onClick={handleApptDetailsAccordion}>
              <div
                style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
              >
                <div>
                  <Icon
                    name={showAppointmentDetails ? "chevron up" : "chevron down"}
                    className="chevron-down"
                  />
                  <label className="accordion-title">Install appointment details</label>
                </div>
                <p className="price font-bold font-18">
                  ${Number(installationTotalCost).toFixed(2)}
                </p>
              </div>
            </Accordion.Title>
            <Accordion.Content active={showAppointmentDetails}>
              <div className="shop-details-container">
                <div className="shop-name">
                  <p className="font-bold font-18 margin-0">{shop?.shop_name}</p>
                  <a style={{ color: "#3C3C3C", cursor: "pointer" }} onClick={() => history.go(-2)}>
                    <u>Change</u>
                  </a>
                </div>
                <p className="margin-0">{shop?.address_line1}</p>
                <p className="margin-0">
                  {shop?.city}, {shop?.state} {shop?.zip}
                </p>
                <div className="shop-phone">
                  <img src={phoneIcon} />
                  <p className="margin-0">{shop?.phone_number}</p>
                </div>
                <div className="appt-date-time-row">
                  <div className="appt-date-time">
                    <img src={calendarIcon} />
                    {formatDate(date)} | {formatTime(time)}
                  </div>
                  <a
                    style={{ color: "#3C3C3C", cursor: "pointer" }}
                    onClick={() => history.goBack()}
                  >
                    <u>Change</u>
                  </a>
                </div>
              </div>
              <div className="appt-pricing-details">
                <div className="installation-cost">
                  <p>Installation (of {tireQuantity} tires)</p>
                  <div style={{ textAlign: "right" }}>
                    <p className="margin-0 font-bold">${orderDetails?.installation_fee}</p>
                    <p>${orderDetails?.installation_fee / tireQuantity} / tire</p>
                  </div>
                </div>
                <div className="subtotal">
                  <p>Subtotal</p>
                  <p className="font-bold margin-0">${orderDetails?.installation_fee}</p>
                </div>
                <PromotionalCodeLink />
                <div className="tire-install-total">
                  <p className="font-bold">Tire install total</p>
                  <p className="margin-0 font-bold">${Number(installationTotalCost).toFixed(2)}</p>
                </div>
              </div>
            </Accordion.Content>
          </Accordion>
          <hr className="horizontal-rule" />
          <div className="flex flex-row justify-between">
            <p>Taxes</p>
            <p className="font-bold">${totalTax}</p>
          </div>
          <div className="convenience-fee">
            <p>Convenience fee</p>
            <p className="margin-0 font-bold">
              ${Number(orderDetails?.transaction_fee).toFixed(2)}
            </p>
          </div>
          <div className="order-total">
            <p className="margin-0 font-bold font-18">Order Total</p>
            <p className="margin-0 font-bold font-18">
              $
              {Number(orderTotal).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </p>
          </div>
          {getSubdomain() !== FLEETCOR && (
            <>
              <div className="py-[10px]">
                <Dropdown
                  options={paymentMethodsDropdown}
                  placeholder="Select Payment Method"
                  defaultValue={defaultPaymentMethod?.id}
                  search
                  selection
                  fluid
                  onChange={(e, data) => {
                    const selectedPM = paymentMethods.find((pm) => pm.id === data.value)
                    setDefaultPaymentMethod(selectedPM)
                  }}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "8px" }}>
                <Popup
                  content={
                    <div style={{ fontSize: "14px" }}>
                      To add a payment method, go to Account Settings.
                      <br />
                      <button
                        className="got-it-btn"
                        onClick={(e) => {
                          e.stopPropagation()
                          document.body.click()
                        }}
                      >
                        Got it
                      </button>
                    </div>
                  }
                  on="click"
                  inverted
                  position={window.innerWidth > "600" ? "right center" : "bottom center"}
                  trigger={
                    <a style={{ color: "#3C3C3C", cursor: "pointer" }}>
                      <u>Do you want to add a payment method?</u>
                    </a>
                  }
                />
              </div>
            </>
          )}
          <div className="payment-info-banner">
            <img src={infoIcon} className="info-icon" />
            <p>
              <b>You will be charged now!</b> Once the order is placed, your tires will be shipped
              to the shop you've selected.
            </p>
          </div>
        </div>
      </div>
      <TiresBottomNav
        goBack={() => history.goBack()}
        nextBtnText={"Buy Tires & Book Install"}
        nextDisabled={defaultPaymentMethod || getSubdomain() === FLEETCOR}
        next={bookTires}
        loading={orderLoading}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  const user = state.application.userSessionData || (state.users && state.users.currentUser)
  const tire = state.tires.tireDetails
  const vehicle = state.tires.vehicle
  const shop = state.tires.selectedShop
  const tireQuantity = state.tires.tireQuantity

  return {
    user,
    shop,
    tire,
    vehicle,
    date: state.tires.date,
    time: state.tires.time,
    selectedTireQuantity: tireQuantity
  }
}

export default connect(mapStateToProps)(Confirmation)
